import { PerpMarketConfig } from '@velocity-exchange/sdk';
import dayjs from 'dayjs';
import { MarketCategory } from 'src/constants/markets';

/** NaN when the market has no 24h window to compare against, e.g. a new listing. */
export function getMarketSelectorPricePercentChange(
	markPrice: number,
	price24hAgo: number
) {
	if (
		!Number.isFinite(price24hAgo) ||
		!price24hAgo ||
		!Number.isFinite(markPrice) ||
		!markPrice
	) {
		return NaN;
	}

	return 100 * ((markPrice - price24hAgo) / price24hAgo);
}

const NEW_AND_TRENDING_WEEKS = 3;

export function perpMarketCategoryFilter(
	market: PerpMarketConfig,
	marketCategory: MarketCategory,
	isHot: boolean
) {
	if (marketCategory === 'all') {
		return true;
	}

	if (marketCategory === 'newAndTrending') {
		return (
			dayjs(market.launchTs)
				.add(NEW_AND_TRENDING_WEEKS, 'week')
				.isAfter(dayjs()) || isHot
		);
	}

	return false;
}
